import { Video as SessionVideo } from '../../services/sessionModels';

export type Video = SessionVideo;

export type Coordinate = {
  x: number;
  y: number;
  z?: number;
  track_id?: string;
  frame_id?: number;
};

export enum PivotOption {
  TopLeft,
  TopCenter,
  TopRight,
  MidLeft,
  MidCenter,
  MidRight,
  BottomLeft,
  BottomCenter,
  BottomRight,
};

export type VideoOverlayObject = {
  svg: any;
  center: Coordinate;
  width: number;
  height: number;
  centerViewOnObject?: boolean;
  disableAutoScale?: boolean;
  pivot?: PivotOption;
};
